var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgListingGuests = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 26 44"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  stroke: "#464646"
}, /*#__PURE__*/React.createElement("path", {
  d: "M7.728 41.062v.431a1.007 1.007 0 0 1-2.014 0v-.439M20.287 41.062v.431a1.007 1.007 0 0 1-2.014 0v-.439"
}), /*#__PURE__*/React.createElement("path", {
  d: "M25.5 39.451c0 1.103-.917 1.998-2.049 1.998H2.548C1.418 41.45.5 40.555.5 39.451V8.447c0-1.103.918-1.998 2.048-1.998h20.903c1.131 0 2.049.895 2.049 1.998v31.004Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22.5 36.451c0 1.103-.917 1.998-2.049 1.998H5.548c-1.13 0-2.048-.894-2.048-1.998V23.447c0-1.103.918-1.998 2.048-1.998h14.903c1.131 0 2.049.895 2.049 1.998v13.004ZM22.5 16.451c0 1.103-.917 1.998-2.049 1.998H5.548c-1.13 0-2.048-.894-2.048-1.998v-5.004c0-1.103.918-1.998 2.048-1.998h14.903c1.131 0 2.049.895 2.049 1.998v5.004ZM6.339 24.45h13.248M6.339 12.45h13.248M16.61 6.3V.605M9.61 6.3V.605"
}), /*#__PURE__*/React.createElement("path", {
  strokeLinecap: "square",
  d: "M8.5.5h9"
}))));
export default SvgListingGuests;